

















































































import Vue, { PropOptions } from 'vue';

import SCard from '@stratumfive/ui-baseplate/src/components/SCard/SCard.vue';
import SIcon from '@stratumfive/ui-baseplate/src/components/SIcon/SIcon.vue';
import SPopup from '@stratumfive/ui-baseplate/src/components/SPopup/SPopup.vue';

import { Field } from '../field';
import { getFieldsById } from '../utils/helpers';

/**
 * Component to display fields within a group.
 */
export default Vue.extend({
  name: 'GroupField',
  components: {
    SCard,
    SIcon,
    SPopup,
    FieldDelegator: () => import('../../forms/components/FieldDelegator.vue'),
  },
  props: {
    field: {
      type: Object,
      required: true,
    } as PropOptions <Field>,
    positionIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  /**
   * Access to all fields of the form from `SnapshotForm.vue`.
   */
  inject: ['allFields'],
  data(): any {
    return {
      folded: false,
      showGroupDescription: false,
      inView: false,
      observer: null,
      fieldsWithTables: [
        'bunker-surveys',
        'bunker-stems',
        'storage-and-content',
        'consumption',
      ],
    };
  },
  computed: {
    allFormFields(): Field[] {
      return this.allFields();
    },
    childFields(): Field[] {
      return getFieldsById({ ids: this.field.fieldDef.children, fields: this.allFormFields });
    },
    groupDescription(): string {
      return this.field.fieldDef.description || '';
    },
    /**
     * Loops through the groups fields and returns a string
     * based on if/the most severe errors.
     */
    errorLevel(): string {
      let errorString = 'valid';

      const childFieldsToCheck = this.childFields.filter((childField) => childField.state.visible);

      childFieldsToCheck.forEach((childField) => {
        childField.getErrors().forEach((error) => {
          if (error.level === 'critical') {
            errorString = 'critical';
          }

          if (error.level === 'warning' && errorString !== 'critical') {
            errorString = 'warning';
          }
        });
      });

      return errorString;
    },
    validityIcon(): string {
      const { errorLevel } = this;

      if (!errorLevel) return '';

      if (errorLevel === 'critical') return 'error';
      if (errorLevel === 'warning') return 'warning';
      return 'check_circle';
    },
    validityColour(): string {
      const { errorLevel } = this;

      if (!errorLevel) return '';

      if (errorLevel === 'critical') return 'error';
      if (errorLevel === 'warning') return 'warning';
      return 'success';
    },
    isVisible(): boolean {
      return this.field.state.visible;
    },
  },
  created() {
    if (this.positionIndex < 3) {
      this.inView = true;
    } else {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            this.inView = true;
            this.observer.unobserve(entry.target);
          }
        });
      });
    }
  },
  mounted() {
    /**
     * Create a timeout for observing the group. We use the positionIndex to
     * offset this, but it will never be longer than 1 second.
     */
    setTimeout(() => {
      if (this.observer) {
        this.observer.observe(this.$refs.groupField);
      }
    }, Math.min((this.positionIndex * 50), 1000));
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    /**
     * If the field has a table in it, we want this to
     * be flush with its containing card.
     */
    fieldHasTable(field: Field): boolean {
      return this.fieldsWithTables.indexOf(field.fieldDef.type) > -1;
    },
  },
});
